// Generated from docs/api/core-api.openapi.json. Keep operation IDs in sync with pnpm openapi:check.
export const CORE_API_OPERATIONS = [
    {
        method: 'GET',
        operationId: 'getHealth',
        path: '/health',
        pathParameters: [],
        tags: ['system'],
    },
    {
        method: 'GET',
        operationId: 'getReadiness',
        path: '/ready',
        pathParameters: [],
        tags: ['system'],
    },
    {
        method: 'GET',
        operationId: 'getAppVersionCheck',
        path: '/v1/app-version-check',
        pathParameters: [],
        tags: ['system'],
    },
    {
        method: 'GET',
        operationId: 'getLocalObjectStorageObject',
        path: '/local-object-storage/{objectKey}',
        pathParameters: ['objectKey'],
        tags: ['local-object-storage'],
    },
    {
        method: 'PUT',
        operationId: 'putLocalObjectStorageObject',
        path: '/local-object-storage/{objectKey}',
        pathParameters: ['objectKey'],
        tags: ['local-object-storage'],
    },
    {
        method: 'GET',
        operationId: 'listLomePricing',
        path: '/v1/pricing/lome',
        pathParameters: [],
        tags: ['pricing'],
    },
    {
        method: 'POST',
        operationId: 'ingestPaymentWebhook',
        path: '/v1/payments/webhooks',
        pathParameters: [],
        tags: ['payments'],
    },
    {
        method: 'POST',
        operationId: 'ingestPayDunyaIpn',
        path: '/v1/payments/paydunya/ipn',
        pathParameters: [],
        tags: ['payments'],
    },
    {
        method: 'POST',
        operationId: 'startOtpChallenge',
        path: '/v1/auth/otp/start',
        pathParameters: [],
        tags: ['auth'],
    },
    {
        method: 'POST',
        operationId: 'verifyOtpChallenge',
        path: '/v1/auth/otp/verify',
        pathParameters: [],
        tags: ['auth'],
    },
    {
        method: 'POST',
        operationId: 'answerDormantChallenge',
        path: '/v1/auth/dormant-challenges/{challengeId}/answer',
        pathParameters: ['challengeId'],
        tags: ['auth'],
    },
    {
        method: 'POST',
        operationId: 'dormantChallengeNotMe',
        path: '/v1/auth/dormant-challenges/{challengeId}/not-me',
        pathParameters: ['challengeId'],
        tags: ['auth'],
    },
    {
        method: 'POST',
        operationId: 'refreshAuthSession',
        path: '/v1/auth/refresh',
        pathParameters: [],
        tags: ['auth'],
    },
    {
        method: 'POST',
        operationId: 'setupOperatorTotp',
        path: '/v1/auth/totp/setup',
        pathParameters: [],
        tags: ['auth', 'operator'],
    },
    {
        method: 'POST',
        operationId: 'verifyOperatorTotp',
        path: '/v1/auth/totp/verify',
        pathParameters: [],
        tags: ['auth', 'operator'],
    },
    {
        method: 'POST',
        operationId: 'resetOperatorTotp',
        path: '/v1/operator/operators/{operatorUserId}/totp/reset',
        pathParameters: ['operatorUserId'],
        tags: ['operator', 'auth'],
    },
    {
        method: 'POST',
        operationId: 'retirePhoneNumber',
        path: '/v1/operator/identity/phone-retirements',
        pathParameters: [],
        tags: ['operator', 'identity'],
    },
    {
        method: 'POST',
        operationId: 'clearDormantContact',
        path: '/v1/operator/identity/dormant-contacts/clear',
        pathParameters: [],
        tags: ['operator', 'identity', 'paid-beta'],
    },
    {
        method: 'GET',
        operationId: 'listDormantRetirements',
        path: '/v1/operator/identity/dormant-retirements',
        pathParameters: [],
        tags: ['operator', 'identity'],
    },
    {
        method: 'POST',
        operationId: 'moveRetiredSubscriberToNewPhone',
        path: '/v1/operator/identity/phone-moves',
        pathParameters: [],
        tags: ['operator', 'identity'],
    },
    {
        method: 'POST',
        operationId: 'restrictSubject',
        path: '/v1/operator/identity/restrictions',
        pathParameters: [],
        tags: ['operator', 'identity'],
    },
    {
        method: 'POST',
        operationId: 'liftSubjectRestriction',
        path: '/v1/operator/identity/restrictions/{restrictionId}/lift',
        pathParameters: ['restrictionId'],
        tags: ['operator', 'identity'],
    },
    {
        method: 'POST',
        operationId: 'registerPushDevice',
        path: '/v1/devices/push-token',
        pathParameters: [],
        tags: ['devices'],
    },
    {
        method: 'GET',
        operationId: 'getSubscriberProfile',
        path: '/v1/subscriber/profile',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'PUT',
        operationId: 'upsertSubscriberProfile',
        path: '/v1/subscriber/profile',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'changeSubscriberPhoneNumber',
        path: '/v1/subscriber/profile/phone-change',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'createSubscriberAvatarUpload',
        path: '/v1/subscriber/profile/avatar-uploads',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'recordSubscriberBehaviorEvent',
        path: '/v1/subscriber/behavior-events',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'GET',
        operationId: 'getCurrentSubscriberSubscription',
        path: '/v1/subscriber/subscription',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'createCurrentSubscriberSubscription',
        path: '/v1/subscriber/subscription',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'GET',
        operationId: 'getCurrentSubscriberNotificationPreferences',
        path: '/v1/subscriber/notification-preferences',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'PUT',
        operationId: 'updateCurrentSubscriberNotificationPreferences',
        path: '/v1/subscriber/notification-preferences',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'createCurrentSubscriberAddressChangeRequest',
        path: '/v1/subscriber/subscription/address-change-requests',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'GET',
        operationId: 'listCurrentSubscriberSubscriptionBillingHistory',
        path: '/v1/subscriber/subscription/billing-history',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'cancelCurrentSubscriberSubscription',
        path: '/v1/subscriber/subscription/cancel',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'requestCurrentSubscriberFirstVisit',
        path: '/v1/subscriber/subscription/first-visit-request',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'pauseCurrentSubscriberSubscription',
        path: '/v1/subscriber/subscription/pause',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'resumeCurrentSubscriberSubscription',
        path: '/v1/subscriber/subscription/resume',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'PUT',
        operationId: 'updateCurrentSubscriberPaymentMethod',
        path: '/v1/subscriber/subscription/payment-method',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'changeCurrentSubscriberSubscriptionTier',
        path: '/v1/subscriber/subscription/tier',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'DELETE',
        operationId: 'cancelScheduledSubscriberTierChange',
        path: '/v1/subscriber/subscription/tier/scheduled',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'createCurrentSubscriberWorkerSwapRequest',
        path: '/v1/subscriber/subscription/worker-swap-requests',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'GET',
        operationId: 'getCurrentSubscriberVisitDetail',
        path: '/v1/subscriber/subscription/visits/{visitId}',
        pathParameters: ['visitId'],
        tags: ['subscriber'],
    },
    {
        method: 'GET',
        operationId: 'getCurrentSubscriberVisitTracking',
        path: '/v1/subscriber/subscription/visits/{visitId}/tracking',
        pathParameters: ['visitId'],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'rescheduleCurrentSubscriberVisit',
        path: '/v1/subscriber/subscription/visits/{visitId}/reschedule',
        pathParameters: ['visitId'],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'skipCurrentSubscriberVisit',
        path: '/v1/subscriber/subscription/visits/{visitId}/skip',
        pathParameters: ['visitId'],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'createCurrentSubscriberVisitDispute',
        path: '/v1/subscriber/subscription/visits/{visitId}/disputes',
        pathParameters: ['visitId'],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'rateCurrentSubscriberVisit',
        path: '/v1/subscriber/subscription/visits/{visitId}/rating',
        pathParameters: ['visitId'],
        tags: ['subscriber'],
    },
    {
        method: 'GET',
        operationId: 'listCurrentSubscriberSupportContacts',
        path: '/v1/subscriber/subscription/support-contacts',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'createCurrentSubscriberSupportContact',
        path: '/v1/subscriber/subscription/support-contacts',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'GET',
        operationId: 'getCurrentSubscriberSupportContact',
        path: '/v1/subscriber/subscription/support-contacts/{contactId}',
        pathParameters: ['contactId'],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'createCurrentSubscriberSupportContactMessage',
        path: '/v1/subscriber/subscription/support-contacts/{contactId}/messages',
        pathParameters: ['contactId'],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'createCurrentSubscriberPrivacyRequest',
        path: '/v1/subscriber/subscription/privacy-requests',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'createSubscription',
        path: '/v1/subscriptions',
        pathParameters: [],
        tags: ['subscriptions'],
    },
    {
        method: 'POST',
        operationId: 'assignSubscriptionWorker',
        path: '/v1/subscriptions/{subscriptionId}/assignment',
        pathParameters: ['subscriptionId'],
        tags: ['subscriptions'],
    },
    {
        method: 'POST',
        operationId: 'declineAssignmentCandidate',
        path: '/v1/operator/subscriptions/{subscriptionId}/assignment-decisions',
        pathParameters: ['subscriptionId'],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'getSubscriptionDetail',
        path: '/v1/subscriptions/{subscriptionId}',
        pathParameters: ['subscriptionId'],
        tags: ['subscriptions'],
    },
    {
        method: 'GET',
        operationId: 'listSubscriptionBillingHistory',
        path: '/v1/subscriptions/{subscriptionId}/billing-history',
        pathParameters: ['subscriptionId'],
        tags: ['subscriptions'],
    },
    {
        method: 'POST',
        operationId: 'cancelSubscription',
        path: '/v1/subscriptions/{subscriptionId}/cancel',
        pathParameters: ['subscriptionId'],
        tags: ['subscriptions'],
    },
    {
        method: 'POST',
        operationId: 'changeSubscriptionTier',
        path: '/v1/subscriptions/{subscriptionId}/tier',
        pathParameters: ['subscriptionId'],
        tags: ['subscriptions'],
    },
    {
        method: 'POST',
        operationId: 'chargeSubscriptionMock',
        path: '/v1/subscriptions/{subscriptionId}/mock-charge',
        pathParameters: ['subscriptionId'],
        tags: ['subscriptions'],
    },
    {
        method: 'POST',
        operationId: 'createWorkerSwapRequest',
        path: '/v1/subscriptions/{subscriptionId}/worker-swap-requests',
        pathParameters: ['subscriptionId'],
        tags: ['subscriptions'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorMatchingQueue',
        path: '/v1/operator/matching-queue',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'getOperatorMe',
        path: '/v1/operator/me',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'PUT',
        operationId: 'updateOperatorDisplayName',
        path: '/v1/operator/me/display-name',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'PUT',
        operationId: 'upsertOperatorWorkerProfile',
        path: '/v1/operator/workers/{workerId}/profile',
        pathParameters: ['workerId'],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listWorkerOnboardingCases',
        path: '/v1/operator/worker-onboarding-cases',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'createWorkerOnboardingCase',
        path: '/v1/operator/worker-onboarding-cases',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'advanceWorkerOnboardingCase',
        path: '/v1/operator/worker-onboarding-cases/{caseId}/advance',
        pathParameters: ['caseId'],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listSubscriptionMatchingCandidates',
        path: '/v1/operator/subscriptions/{subscriptionId}/matching-candidates',
        pathParameters: ['subscriptionId'],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorServiceCells',
        path: '/v1/operator/service-cells',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorAuditEvents',
        path: '/v1/operator/audit-events',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorNotifications',
        path: '/v1/operator/notifications',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorPaymentAttempts',
        path: '/v1/operator/payment-attempts',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'getOperatorBetaMetrics',
        path: '/v1/operator/beta-metrics',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'issueOperatorGoodwillCredit',
        path: '/v1/operator/credits',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'issueOperatorSuspension',
        path: '/v1/operator/suspensions',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'requestCurrentSubscriberOwnerIdUpload',
        path: '/v1/subscriber/household/owner-verification/photo-uploads',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'POST',
        operationId: 'submitCurrentSubscriberOwnerVerification',
        path: '/v1/subscriber/household/owner-verification',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'GET',
        operationId: 'getCurrentSubscriberOwnerVerification',
        path: '/v1/subscriber/household/owner-verification',
        pathParameters: [],
        tags: ['subscriber'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorHouseholdVerifications',
        path: '/v1/operator/household-verifications',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'reviewOperatorHouseholdVerification',
        path: '/v1/operator/household-verifications/{verificationId}/review',
        pathParameters: ['verificationId'],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'commitOperatorWorkerCapacity',
        path: '/v1/operator/workers/{workerId}/commitments',
        pathParameters: ['workerId'],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorWorkerCommitments',
        path: '/v1/operator/workers/{workerId}/commitments',
        pathParameters: ['workerId'],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'endOperatorWorkerCommitment',
        path: '/v1/operator/worker-commitments/{commitmentId}/end',
        pathParameters: ['commitmentId'],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listCurrentWorkerCommitments',
        path: '/v1/workers/me/commitments',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'POST',
        operationId: 'resolveOperatorPaymentAttempt',
        path: '/v1/operator/payment-attempts/{paymentAttemptId}/resolution',
        pathParameters: ['paymentAttemptId'],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'issueOperatorPaymentRefund',
        path: '/v1/operator/payment-attempts/{paymentAttemptId}/refunds',
        pathParameters: ['paymentAttemptId'],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'resolveOperatorPaymentRefund',
        path: '/v1/operator/payment-refunds/{refundId}/resolution',
        pathParameters: ['refundId'],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'runOperatorPaymentReconciliation',
        path: '/v1/operator/payment-reconciliation-runs',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'getPaymentProviderReadiness',
        path: '/v1/operator/payment-provider-readiness',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'getInternationalCardProviderReadiness',
        path: '/v1/operator/international-card-provider-readiness',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'getOtpProviderReadiness',
        path: '/v1/operator/otp-provider-readiness',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorSubscriberSupportMatches',
        path: '/v1/operator/subscriber-support-matches',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'getOperatorSubscriptionSupportContext',
        path: '/v1/operator/subscriptions/{subscriptionId}/support-context',
        pathParameters: ['subscriptionId'],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'createOperatorSubscriberPrivacyRequest',
        path: '/v1/operator/subscriptions/{subscriptionId}/privacy-requests',
        pathParameters: ['subscriptionId'],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorPushDevices',
        path: '/v1/operator/push-devices',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'getPushProviderReadiness',
        path: '/v1/operator/push-provider-readiness',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'deliverDueOperatorNotifications',
        path: '/v1/operator/notifications/deliver-due',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerVisitDetail',
        path: '/v1/visits/{visitId}',
        pathParameters: ['visitId'],
        tags: ['visits'],
    },
    {
        method: 'POST',
        operationId: 'checkInVisit',
        path: '/v1/visits/{visitId}/check-in',
        pathParameters: ['visitId'],
        tags: ['visits'],
    },
    {
        method: 'POST',
        operationId: 'checkOutVisit',
        path: '/v1/visits/{visitId}/check-out',
        pathParameters: ['visitId'],
        tags: ['visits'],
    },
    {
        method: 'POST',
        operationId: 'recordVisitLocationSample',
        path: '/v1/visits/{visitId}/location-samples',
        pathParameters: ['visitId'],
        tags: ['visits'],
    },
    {
        method: 'POST',
        operationId: 'reportWorkerIssue',
        path: '/v1/visits/{visitId}/worker-issues',
        pathParameters: ['visitId'],
        tags: ['visits'],
    },
    {
        method: 'POST',
        operationId: 'recordVisitPhoto',
        path: '/v1/visits/{visitId}/photos',
        pathParameters: ['visitId'],
        tags: ['visits'],
    },
    {
        method: 'POST',
        operationId: 'createVisitPhotoUpload',
        path: '/v1/visits/{visitId}/photo-uploads',
        pathParameters: ['visitId'],
        tags: ['visits'],
    },
    {
        method: 'POST',
        operationId: 'rescheduleVisit',
        path: '/v1/subscriptions/{subscriptionId}/visits/{visitId}/reschedule',
        pathParameters: ['subscriptionId', 'visitId'],
        tags: ['subscriptions'],
    },
    {
        method: 'POST',
        operationId: 'skipVisit',
        path: '/v1/subscriptions/{subscriptionId}/visits/{visitId}/skip',
        pathParameters: ['subscriptionId', 'visitId'],
        tags: ['subscriptions'],
    },
    {
        method: 'POST',
        operationId: 'updateOperatorVisitStatus',
        path: '/v1/operator/visits/{visitId}/status',
        pathParameters: ['visitId'],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'createVisitDispute',
        path: '/v1/subscriptions/{subscriptionId}/visits/{visitId}/disputes',
        pathParameters: ['subscriptionId', 'visitId'],
        tags: ['subscriptions'],
    },
    {
        method: 'POST',
        operationId: 'rateVisit',
        path: '/v1/subscriptions/{subscriptionId}/visits/{visitId}/rating',
        pathParameters: ['subscriptionId', 'visitId'],
        tags: ['subscriptions'],
    },
    {
        method: 'GET',
        operationId: 'listSubscriberSupportContacts',
        path: '/v1/subscriptions/{subscriptionId}/support-contacts',
        pathParameters: ['subscriptionId'],
        tags: ['subscriptions'],
    },
    {
        method: 'POST',
        operationId: 'createSubscriberSupportContact',
        path: '/v1/subscriptions/{subscriptionId}/support-contacts',
        pathParameters: ['subscriptionId'],
        tags: ['subscriptions'],
    },
    {
        method: 'GET',
        operationId: 'getSubscriberSupportContact',
        path: '/v1/subscriptions/{subscriptionId}/support-contacts/{contactId}',
        pathParameters: ['subscriptionId', 'contactId'],
        tags: ['subscriptions'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorSosEvents',
        path: '/v1/operator/sos-events',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'resolveOperatorSosEvent',
        path: '/v1/operator/sos-events/{sosEventId}/resolve',
        pathParameters: ['sosEventId'],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorDisputes',
        path: '/v1/operator/disputes',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'resolveOperatorDispute',
        path: '/v1/operator/disputes/{disputeId}/resolve',
        pathParameters: ['disputeId'],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorWorkerIssues',
        path: '/v1/operator/worker-issues',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'resolveOperatorWorkerIssue',
        path: '/v1/operator/worker-issues/{issueId}/resolve',
        pathParameters: ['issueId'],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorWorkerSwapRequests',
        path: '/v1/operator/worker-swap-requests',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'resolveOperatorWorkerSwapRequest',
        path: '/v1/operator/worker-swap-requests/{requestId}/resolve',
        pathParameters: ['requestId'],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listWorkerTodayVisits',
        path: '/v1/workers/me/visits/today',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerMeProfile',
        path: '/v1/workers/me/profile',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerMeEarnings',
        path: '/v1/workers/me/earnings',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'listWorkerMePayouts',
        path: '/v1/workers/me/payouts',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'listWorkerMeAdvanceRequests',
        path: '/v1/workers/me/advance-requests',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'POST',
        operationId: 'createWorkerMeAdvanceRequest',
        path: '/v1/workers/me/advance-requests',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerMeRoute',
        path: '/v1/workers/me/route',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'listWorkerMeUnavailability',
        path: '/v1/workers/me/unavailability',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'POST',
        operationId: 'createWorkerMeUnavailability',
        path: '/v1/workers/me/unavailability',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerMeWeekSchedule',
        path: '/v1/workers/me/visits/week',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'listWorkerMeHouseholds',
        path: '/v1/workers/me/households',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'listWorkerMeHouseholdReviews',
        path: '/v1/workers/me/households/{householdId}/reviews',
        pathParameters: ['householdId'],
        tags: ['workers'],
    },
    {
        method: 'POST',
        operationId: 'createWorkerMeSosEvent',
        path: '/v1/workers/me/sos-events',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'POST',
        operationId: 'createWorkerMeConcernReport',
        path: '/v1/workers/me/concern-reports',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'POST',
        operationId: 'createConcernPhotoUpload',
        path: '/v1/concerns/photo-uploads',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerRoute',
        path: '/v1/workers/{workerId}/route',
        pathParameters: ['workerId'],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerProfile',
        path: '/v1/workers/{workerId}/profile',
        pathParameters: ['workerId'],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'listWorkerUnavailability',
        path: '/v1/workers/{workerId}/unavailability',
        pathParameters: ['workerId'],
        tags: ['workers'],
    },
    {
        method: 'POST',
        operationId: 'createWorkerUnavailability',
        path: '/v1/operator/workers/{workerId}/unavailability',
        pathParameters: ['workerId'],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerEarnings',
        path: '/v1/workers/{workerId}/earnings',
        pathParameters: ['workerId'],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'listWorkerPayouts',
        path: '/v1/workers/{workerId}/payouts',
        pathParameters: ['workerId'],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'listWorkerAdvanceRequests',
        path: '/v1/workers/{workerId}/advance-requests',
        pathParameters: ['workerId'],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'getCapacityExposure',
        path: '/v1/operator/finance/capacity-exposure',
        pathParameters: [],
        tags: ['operator', 'payouts', 'metrics'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerPayoutPreview',
        path: '/v1/operator/workers/{workerId}/payout-preview',
        pathParameters: ['workerId'],
        tags: ['operator', 'payouts'],
    },
    {
        method: 'POST',
        operationId: 'recordWorkerPayout',
        path: '/v1/operator/workers/{workerId}/payouts',
        pathParameters: ['workerId'],
        tags: ['operator', 'payouts'],
    },
    {
        method: 'PUT',
        operationId: 'setOperatorWorkerPayoutDestination',
        path: '/v1/operator/workers/{workerId}/payout-destination',
        pathParameters: ['workerId'],
        tags: ['operator', 'payouts'],
    },
    {
        method: 'POST',
        operationId: 'payWorkerAdvance',
        path: '/v1/operator/worker-advance-requests/{requestId}/payouts',
        pathParameters: ['requestId'],
        tags: ['operator', 'payouts'],
    },
    {
        method: 'POST',
        operationId: 'resolveWorkerPayout',
        path: '/v1/operator/worker-payouts/{payoutId}/resolution',
        pathParameters: ['payoutId'],
        tags: ['operator', 'payouts'],
    },
    {
        method: 'GET',
        operationId: 'listWorkerPayoutAttention',
        path: '/v1/operator/worker-payouts/attention',
        pathParameters: [],
        tags: ['operator', 'payouts'],
    },
    {
        method: 'POST',
        operationId: 'createOperatorWorkerMonthlyPayout',
        path: '/v1/operator/workers/{workerId}/monthly-payouts',
        pathParameters: ['workerId'],
        tags: ['operator'],
    },
    {
        method: 'GET',
        operationId: 'listOperatorWorkerAdvanceRequests',
        path: '/v1/operator/worker-advance-requests',
        pathParameters: [],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'resolveOperatorWorkerAdvanceRequest',
        path: '/v1/operator/worker-advance-requests/{requestId}/resolve',
        pathParameters: ['requestId'],
        tags: ['operator'],
    },
    {
        method: 'POST',
        operationId: 'verifyWorkerPin',
        path: '/v1/auth/pin/verify',
        pathParameters: [],
        tags: ['auth'],
    },
    {
        method: 'POST',
        operationId: 'requestPinResetByOperator',
        path: '/v1/operator/workers/{workerId}/pin-reset',
        pathParameters: ['workerId'],
        tags: ['operator', 'workers'],
    },
    {
        method: 'GET',
        operationId: 'listWorkerMeNotifications',
        path: '/v1/workers/me/notifications',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerMeNotification',
        path: '/v1/workers/me/notifications/{notificationId}',
        pathParameters: ['notificationId'],
        tags: ['workers'],
    },
    {
        method: 'POST',
        operationId: 'markWorkerMeNotificationRead',
        path: '/v1/workers/me/notifications/{notificationId}/mark-read',
        pathParameters: ['notificationId'],
        tags: ['workers'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerMeRecap',
        path: '/v1/workers/me/recap',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'POST',
        operationId: 'registerWorkerMePushDevice',
        path: '/v1/workers/me/push-devices',
        pathParameters: [],
        tags: ['workers'],
    },
    {
        method: 'POST',
        operationId: 'setWorkerMePin',
        path: '/v1/workers/me/pin',
        pathParameters: [],
        tags: ['workers', 'auth'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerMePersonalDetails',
        path: '/v1/workers/me/personal-details',
        pathParameters: [],
        tags: ['workers', 'settings'],
    },
    {
        method: 'PUT',
        operationId: 'updateWorkerMePersonalDetails',
        path: '/v1/workers/me/personal-details',
        pathParameters: [],
        tags: ['workers', 'settings'],
    },
    {
        method: 'POST',
        operationId: 'requestWorkerMeSelfieUploadUrl',
        path: '/v1/workers/me/selfie/upload-url',
        pathParameters: [],
        tags: ['workers', 'settings'],
    },
    {
        method: 'POST',
        operationId: 'commitWorkerMeSelfie',
        path: '/v1/workers/me/selfie',
        pathParameters: [],
        tags: ['workers', 'settings'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerMePayoutDestination',
        path: '/v1/workers/me/payout-destination',
        pathParameters: [],
        tags: ['workers', 'settings'],
    },
    {
        method: 'PUT',
        operationId: 'updateWorkerMePayoutDestination',
        path: '/v1/workers/me/payout-destination',
        pathParameters: [],
        tags: ['workers', 'settings'],
    },
    {
        method: 'POST',
        operationId: 'createOperatorCommercialAccordSubscription',
        path: '/v1/operator/subscriptions/commercial-accord',
        pathParameters: [],
        tags: ['operator', 'subscriptions'],
    },
    {
        method: 'GET',
        operationId: 'listSubscriptionFamilyMembers',
        path: '/v1/subscriptions/{subscriptionId}/family-members',
        pathParameters: ['subscriptionId'],
        tags: ['subscriptions', 'family-plan'],
    },
    {
        method: 'POST',
        operationId: 'createSubscriptionFamilyMember',
        path: '/v1/subscriptions/{subscriptionId}/family-members',
        pathParameters: ['subscriptionId'],
        tags: ['subscriptions', 'family-plan'],
    },
    {
        method: 'PATCH',
        operationId: 'updateSubscriptionFamilyMember',
        path: '/v1/subscriptions/{subscriptionId}/family-members/{memberId}',
        pathParameters: ['subscriptionId', 'memberId'],
        tags: ['subscriptions', 'family-plan'],
    },
    {
        method: 'DELETE',
        operationId: 'removeSubscriptionFamilyMember',
        path: '/v1/subscriptions/{subscriptionId}/family-members/{memberId}',
        pathParameters: ['subscriptionId', 'memberId'],
        tags: ['subscriptions', 'family-plan'],
    },
    {
        method: 'POST',
        operationId: 'recordVisitGrace',
        path: '/v1/visits/{visitId}/grace',
        pathParameters: ['visitId'],
        tags: ['visits', 'family-plan'],
    },
    {
        method: 'GET',
        operationId: 'listVisitFamilyMembers',
        path: '/v1/visits/{visitId}/family-members',
        pathParameters: ['visitId'],
        tags: ['visits', 'family-plan'],
    },
    {
        method: 'GET',
        operationId: 'getWorkerMeNotificationPreferences',
        path: '/v1/workers/me/notification-preferences',
        pathParameters: [],
        tags: ['workers', 'settings'],
    },
    {
        method: 'PUT',
        operationId: 'updateWorkerMeNotificationPreferences',
        path: '/v1/workers/me/notification-preferences',
        pathParameters: [],
        tags: ['workers', 'settings'],
    },
    {
        method: 'POST',
        operationId: 'ingestInternationalCardWebhook',
        path: '/v1/payments/international-card/webhooks',
        pathParameters: [],
        tags: ['payments', 'sponsor-pay'],
    },
    {
        method: 'POST',
        operationId: 'createCurrentSubscriberSponsorshipInvite',
        path: '/v1/subscriber/subscription/sponsorship-invites',
        pathParameters: [],
        tags: ['subscriber', 'sponsor-pay'],
    },
    {
        method: 'GET',
        operationId: 'getCurrentSubscriberSponsorship',
        path: '/v1/subscriber/subscription/sponsorship',
        pathParameters: [],
        tags: ['subscriber', 'sponsor-pay'],
    },
    {
        method: 'POST',
        operationId: 'revokeCurrentSubscriberSponsorship',
        path: '/v1/subscriber/subscription/sponsorship/revoke',
        pathParameters: [],
        tags: ['subscriber', 'sponsor-pay'],
    },
    {
        method: 'POST',
        operationId: 'attachCurrentSubscriberSponsorFallbackPaymentMethod',
        path: '/v1/subscriber/subscription/sponsorship/local-fallback',
        pathParameters: [],
        tags: ['subscriber', 'sponsor-pay'],
    },
    {
        method: 'GET',
        operationId: 'getSponsorInvite',
        path: '/v1/sponsor/invites/{token}',
        pathParameters: ['token'],
        tags: ['sponsor-pay'],
    },
    {
        method: 'GET',
        operationId: 'getSponsorInviteQuote',
        path: '/v1/sponsor/invites/{token}/quote',
        pathParameters: ['token'],
        tags: ['sponsor-pay'],
    },
    {
        method: 'POST',
        operationId: 'startSponsorInviteCheckout',
        path: '/v1/sponsor/invites/{token}/checkout',
        pathParameters: ['token'],
        tags: ['sponsor-pay'],
    },
    {
        method: 'POST',
        operationId: 'runOperatorSponsorPayMaintenance',
        path: '/v1/operator/sponsor-pay/maintenance',
        pathParameters: [],
        tags: ['operator', 'sponsor-pay'],
    },
    {
        method: 'POST',
        operationId: 'submitMarketingWaitlist',
        path: '/v1/marketing/waitlist',
        pathParameters: [],
        tags: ['marketing'],
    },
    {
        method: 'POST',
        operationId: 'requestPartnerLogin',
        path: '/v1/partner/auth/request',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'verifyPartnerLogin',
        path: '/v1/partner/auth/verify',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'GET',
        operationId: 'getPartnerMe',
        path: '/v1/partner/me',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'logoutPartner',
        path: '/v1/partner/auth/logout',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'getPartnerPasskeyRegistrationOptions',
        path: '/v1/partner/passkeys/register/options',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'registerPartnerPasskey',
        path: '/v1/partner/passkeys/register',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'getPartnerPasskeySignInOptions',
        path: '/v1/partner/passkeys/sign-in/options',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'signInPartnerWithPasskey',
        path: '/v1/partner/passkeys/sign-in',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'GET',
        operationId: 'listPartnerPasskeys',
        path: '/v1/partner/passkeys',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'removePartnerPasskey',
        path: '/v1/partner/passkeys/remove',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'acceptPartnerTerms',
        path: '/v1/partner/terms/accept',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'GET',
        operationId: 'getPartnerDashboard',
        path: '/v1/partner/dashboard',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'GET',
        operationId: 'getPartnerCode',
        path: '/v1/partner/code',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'changePartnerCode',
        path: '/v1/partner/code',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'GET',
        operationId: 'checkPartnerCodeAvailability',
        path: '/v1/partner/code/availability',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'GET',
        operationId: 'listPaidBetaPartners',
        path: '/v1/operator/paid-beta/partners',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'invitePaidBetaPartner',
        path: '/v1/operator/paid-beta/partners',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'GET',
        operationId: 'getOperatorPartnerDashboard',
        path: '/v1/operator/paid-beta/partners/{id}/dashboard',
        pathParameters: ['id'],
        tags: ['partners'],
    },
    {
        method: 'GET',
        operationId: 'getPartnerProgramBudget',
        path: '/v1/operator/paid-beta/partners/budget',
        pathParameters: [],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'reviewPartnerReferral',
        path: '/v1/operator/paid-beta/partners/{id}/referrals/{referralId}/review',
        pathParameters: ['id', 'referralId'],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'sendPartnerInvitation',
        path: '/v1/operator/paid-beta/partners/{id}/invitation',
        pathParameters: ['id'],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'changePartnerEmail',
        path: '/v1/operator/paid-beta/partners/{id}/email',
        pathParameters: ['id'],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'changeOperatorPartnerCode',
        path: '/v1/operator/paid-beta/partners/{id}/code',
        pathParameters: ['id'],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'suspendPartner',
        path: '/v1/operator/paid-beta/partners/{id}/suspend',
        pathParameters: ['id'],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'reactivatePartner',
        path: '/v1/operator/paid-beta/partners/{id}/reactivate',
        pathParameters: ['id'],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'voidPartnerPayout',
        path: '/v1/operator/paid-beta/partners/{id}/payouts/{payoutId}/void',
        pathParameters: ['id', 'payoutId'],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'recordPartnerPayout',
        path: '/v1/operator/paid-beta/partners/{id}/payouts',
        pathParameters: ['id'],
        tags: ['partners'],
    },
    {
        method: 'POST',
        operationId: 'recordPartnerVolumeReview',
        path: '/v1/operator/paid-beta/partners/{id}/volume-review',
        pathParameters: ['id'],
        tags: ['partners'],
    },
    {
        method: 'GET',
        operationId: 'checkPaidBetaAcquisitionCode',
        path: '/v1/channel/whatsapp/acquisition/codes/{code}',
        pathParameters: ['code'],
        tags: ['whatsapp-channel', 'paid-beta'],
    },
    {
        method: 'POST',
        operationId: 'attributePaidBetaCampaign',
        path: '/v1/channel/whatsapp/acquisition/attributions',
        pathParameters: [],
        tags: ['whatsapp-channel', 'paid-beta'],
    },
    {
        method: 'GET',
        operationId: 'listPaidBetaCampaignStatements',
        path: '/v1/operator/paid-beta/acquisition/campaigns',
        pathParameters: [],
        tags: ['operator', 'paid-beta'],
    },
    {
        method: 'GET',
        operationId: 'readPaidBetaHouseholdAcquisition',
        path: '/v1/operator/paid-beta/households/{householdId}/acquisition',
        pathParameters: ['householdId'],
        tags: ['operator', 'paid-beta'],
    },
    {
        method: 'POST',
        operationId: 'correctPaidBetaHouseholdAcquisition',
        path: '/v1/operator/paid-beta/households/{householdId}/acquisition',
        pathParameters: ['householdId'],
        tags: ['operator', 'paid-beta'],
    },
];
//# sourceMappingURL=operations.js.map